<template>
  <main id="mainPage">
    <!--visual-->
    <section class="visual">
      <article class="txtBox">
        <p>ECHEON TOTAL PARKING SYSTEM</p>
        <h2>이천시 통합주차포털</h2>
      </article>
    </section>
    <!--//visual-->

    <!--content-->
    <section id="content">
      <div class="inner">
        <div class="realtimeArea">
          <h3 class="tit">실시간 주차장 현황</h3>
          <swiper class="parkingList" ref="parkSwiper" :options="parkingSwiperOption">
            <swiper-slide v-for="(parking, index) in parkingList" :key="index">
              <a @click="$router.push(`/list?q=${parking.PARKING_NM}`)" class="card">
                <div class="cardImg">
                  <img
                    :src="checkImg(parking.REPO_ID, parking.FILE_PATH, parking.SAVE_NM, parking.FILE_EXT)"
                    alt="주차장이미지"
                  />
                </div>
                <div class="cardCont">
                  <div class="txt">
                    <p>{{ parking.PARKING_NM }}</p>
                  </div>
                  <table class="mainTable">
                    <caption class="hidden">
                      실시간 주차장 현황 테이블
                    </caption>
                    <colgroup>
                      <col style="width: 50%" />
                      <col style="width: 50%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col"><span class="ico realtime">주차현황</span></th>
                        <th scope="col"><span class="ico total">전체면수</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><!--여유(녹색, 1~70%) / 보통(노랑, 71~85%) / 혼잡(빨강, 86~100%)-->
                          <span class="colorType green" v-if="(parking.CELL_CNT - parking.PARK_COUNT) <= (parking.CELL_CNT * 0.7)">여유</span>
                          <span class="colorType yellow" v-else-if="(parking.CELL_CNT * 0.7) < (parking.CELL_CNT - parking.PARK_COUNT)  && (parking.CELL_CNT - parking.PARK_COUNT) <= (parking.CELL_CNT * 0.85)">보통</span>
                          <span class="colorType red" v-else-if="(parking.CELL_CNT * 0.85) < (parking.CELL_CNT - parking.PARK_COUNT)">혼잡</span>
                          <!-- <span class="colorType red">만차</span> -->
                          <!-- <span class="colorType purple"> {{ parking.PARK_COUNT }} <em>대</em></span> -->
                        </td>
                        <td>
                          <span>{{ parking.CELL_CNT }} <em>대</em></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </a>
            </swiper-slide>
          </swiper>
          <div class="btnControl parking">
            <button class="swiper-button-prev"></button>
            <button class="swiper-button-next"></button>
          </div>
        </div>
        <div class="boardArea">
          <h3 class="tit">공지사항</h3>
          <!--board-->
          <div class="board">
            <ul>
              <li v-for="(notice, index) in noticeList" :key="index">
                <span @click="$router.push(`/noticeview?atclId=${notice.atclId}`)">{{ notice.title }}</span>
                <span class="date">{{ notice.updDttm | ptDateFormat }}</span>
              </li>
            </ul>
          </div>
          <!--//board-->
          <!--service-->
          <div class="service">
            <ul>
              <li class="tell">
                <strong>전화 문의</strong>
                <dl>
                  <dt>주차장 사무실<br />(오전 09:00~오후 6:00)</dt>
                  <dd>031)635-2070</dd>
                </dl>
                <dl>
                  <dt>노외주차장 관제실</dt>
                  <dd>031)631-2071</dd>
                </dl>
              </li>
              <li class="period">
                <strong>정기권 신청안내</strong>
                <strong>통합주차 포털 사이트 및 사무실 접수</strong>
                <p>선착순 마감</p>
              </li>
            </ul>
          </div>
          <!--//service-->
        </div>
      </div>
    </section>
    <!--//content-->

    <popup v-for="(item, index) in popupPropsDataArr" :key="index" v-bind:propsData="item">
      <template #info>
        {{ item.title }}
      </template>
      <template #content>
        <article>
          <p v-html="item.contents"></p>
        </article>
      </template>
      <template #chkbox>
        <p class="checkbox">
          <input
            type="checkbox"
            :id="item.popupId"
            v-model="item.check"
            :value="item.popupId"
            @input="setPopupCookie(item.popupId)"
          />
          <label :for="item.popupId">오늘 하루 열지 않음</label>
        </p>
      </template>
      <template #button> </template>
    </popup>
  </main>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import axios from '../../util/axios';
import Popup from '../../components/PopupType2.vue';

export default {
  components: {
    Swiper,
    SwiperSlide,
    Popup,
  },

  data() {
    return {
      parkingSwiperOption: {
        slidesPerView: 2,
        slidesToShow: 1,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        autoplay: false,
        loop: false,
        slideToClickedSlide: true,
        speed: 400,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.btnControl.parking .swiper-button-next',
          prevEl: '.btnControl.parking .swiper-button-prev',
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 1,
          },
          1300: {
            slidesPerView: 2,
          },
        },
      },

      noticeList: [],
      parkingList: [],
      popupList: [],
      popupPropsDataArr: [],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      const urls = [
        '/api/admin/popup/getPopupList.json',
        '/api/parking/map.json',
        '/api/board/notice/list.json?searchCondition=1&searchKeyword=&bbsCd=notice&recordCountPerPage=4&firstIndex=0',
      ];
      const req = urls.map(url => axios('get', url));
      const res = await Promise.all(req);
      const [popupRes, parkingRes, noticeRes] = await Promise.all(res);

      this.noticeList = noticeRes.data.boardList.slice(0, 5);
      this.parkingList = parkingRes.data.parkingMapList.map(v => ({
        ...v,
        PARK_COUNT: v.PARK_COUNT < 0 ? 0 : v.PARK_COUNT,
      }));
      this.popupList = popupRes.data.resultList;
      this.popupList.forEach(v => {
        this.setPopupProps(v);
      });
    },

    checkImg(repoId, filePath, saveNm, fileExt) {
      if (repoId === null || filePath === null || saveNm === null || fileExt === null) {
        return '../../../src/assets/images/main/noImage.png';
      }
      return '/api/parking/atchfile/' + repoId + '/' + filePath + '/' + saveNm + '.' + fileExt;
    },

    setPopupProps(popupObj) {
      const cookieKey = this.$cookies.get('PORTAL-POPUP-' + popupObj.popupId);
      if (cookieKey === 'N') {
        return;
      }
      const popupData = {
        posX: popupObj.posX,
        posY: popupObj.posY,
        sizeX: popupObj.sizeX,
        sizeY: popupObj.sizeY,
        linkUrl: popupObj.linkUrl,
        title: popupObj.title,
        contents: popupObj.contents,
        repoId: popupObj.repoId,
        filePath: popupObj.filePath,
        saveNm: popupObj.saveNm,
        fileExt: popupObj.fileExt,
        popupId: popupObj.popupId,
        check: false,
      };
      this.popupPropsDataArr.push(popupData);
    },

    setPopupCookie(popupId) {
      const cookieKey = this.$cookies.get('PORTAL-POPUP-' + popupId);
      if (cookieKey === 'N') {
        this.$cookies.remove('PORTAL-POPUP-' + popupId);
        return;
      }
      this.$cookies.set('PORTAL-POPUP-' + popupId, 'N');
    },
  },
};
</script>
